import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type HexachipCurrencyDTO = z.infer<typeof HexachipCurrencyDTORuntype>;
export const HexachipCurrencyDTORuntype = z.enum(['EUR', 'USD', 'CNY']);

export interface HexachipCredentialsDTO extends z.infer<typeof HexachipCredentialsDTORuntype> {}
export const HexachipCredentialsDTORuntype = z.object({
    client_id: z.string(),
    client_secret: z.string(),
    currency: HexachipCurrencyDTORuntype.default('EUR'),
});

export interface HexachipCredentialsInputDTO extends z.infer<typeof HexachipCredentialsInputDTORuntype> {}
export const HexachipCredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    client_secret: z.string().optional(),
    currency: HexachipCurrencyDTORuntype.optional(),
});

export interface HexachipResponseBodyDTO extends z.infer<typeof HexachipResponseBodyDTORuntype> {}
export const HexachipResponseBodyDTORuntype = z.object({
    data: HexachipCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
